(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('med-account-popup')) {
  customElements.define('med-account-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.trigger = this.querySelector('[data-med-account-trigger]');
      this.panel = this.querySelector('.med-account__panel');
      this.closeButton = this.querySelector('[data-med-account-close]');
      if (!this.trigger || !this.panel || !this.closeButton) return;
      this.panel.id = 'med-account-popup-' + crypto.randomUUID();
      this.trigger.setAttribute('aria-controls', this.panel.id);
      this.position = () => {
        const bounds = this.trigger.getBoundingClientRect();
        const width = this.panel.getBoundingClientRect().width || 380;
        const viewportWidth = document.documentElement.clientWidth;
        const top = Math.max(12, Math.min(bounds.bottom + 14, window.innerHeight - 180));
        const left = Math.max(12, Math.min(bounds.right - width, viewportWidth - width - 12));
        this.panel.style.setProperty('--med-account-top', top + 'px');
        this.panel.style.setProperty('--med-account-left', left + 'px');
        this.panel.style.maxHeight = Math.max(160, window.innerHeight - top - 12) + 'px';
      };
      this.trigger.addEventListener('click', () => {
        if (!this.panel.showPopover) {
          window.location.assign(this.querySelector('[data-med-account-email]').href);
          return;
        }
        this.panel.togglePopover();
        if (this.panel.matches(':popover-open')) this.position();
      });
      this.closeButton.addEventListener('click', () => this.panel.hidePopover());
      this.panel.addEventListener('toggle', event => {
        const open = event.newState === 'open';
        this.trigger.setAttribute('aria-expanded', String(open));
        if (open) {
          this.position();
          window.addEventListener('resize', this.position);
          window.addEventListener('scroll', this.position, {passive: true});
        } else {
          window.removeEventListener('resize', this.position);
          window.removeEventListener('scroll', this.position);
        }
      });
      const google = this.querySelector('[data-med-account-google]');
      const googleUrl = new URL(google.href, window.location.origin);
      googleUrl.searchParams.set('return_to', window.location.pathname + window.location.search);
      google.href = googleUrl.href;
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.position);
      window.removeEventListener('scroll', this.position);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["med-engraving-fonts"] && !Shopify.designMode) return;
  try {
    (() => {
    const hostedFaces = new Map();
    let fontSequence = 0;
    class EngravingFont extends HTMLElement {
      connectedCallback() {
        this.parent = this.closest('med-personalizer');
        if (this.parent?.ready) this.initialize(this.parent.fontDraft);
      }
      disconnectedCallback() {
        this.loadToken = (this.loadToken || 0) + 1;
        this.disposeCustomFace();
      }
      initialize(saved) {
        if (this.initialized) return;
        this.initialized = true;
        this.messages = JSON.parse(this.querySelector('[data-font-messages]').textContent);
        this.select = this.querySelector('[data-font-select]');
        this.choices = [...this.querySelectorAll('[data-font-key]')];
        this.upload = this.querySelector('input[type="file"]');
        this.status = this.querySelector('.med-font__status');
        this.property = this.querySelector('[data-font-property]');
        this.hidden = false;
        this.choices.forEach(choice => {
          choice.dataset.ready = String(!choice.dataset.service || (this.serviceAvailable(choice.dataset.service) && (choice.dataset.fontKey === 'custom' || Boolean(choice.dataset.fontUrl))));
          choice.disabled = choice.dataset.ready !== 'true';
          if (choice.disabled) choice.textContent += ` · ${this.messages.option_unavailable}`;
        });
        const previous = this.choices.find(choice => choice.dataset.fontKey === saved?.key && !choice.disabled);
        if (previous) this.select.value = previous.value;
        if (previous?.dataset.fontKey === 'custom' && saved.file instanceof File && typeof DataTransfer !== 'undefined') {
          const transfer = new DataTransfer();
          transfer.items.add(saved.file);
          this.upload.files = transfer.files;
        }
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-font-select], input[type="file"]')) return;
          this.parent.confirm.checked = false;
          this.choose();
        });
        this.labelFontsReady = Promise.allSettled(this.choices.filter(choice => choice.dataset.fontUrl && choice.dataset.ready === 'true').map(async choice => {
          const face = await this.loadNamedFace(choice);
          if (this.isConnected) choice.style.fontFamily = `"${face.family}"`;
        }));
        this.choose();
      }
      async loadNamedFace(choice) {
        const url = new URL(choice.dataset.fontUrl, window.location.href);
        if (!['https:', 'http:'].includes(url.protocol)) throw new Error(this.messages.load_failed);
        const cacheKey = `${choice.dataset.fontKey}:${url.href}`;
        if (!hostedFaces.has(cacheKey)) {
          const promise = new FontFace(`USMedIDHosted${++fontSequence}`, `url(${JSON.stringify(url.href)})`).load();
          hostedFaces.set(cacheKey, promise);
          promise.catch(() => hostedFaces.delete(cacheKey));
        }
        const face = await hostedFaces.get(cacheKey);
        document.fonts.add(face);
        return face;
      }
      serviceAvailable(name) {
        const service = this.querySelector(`[data-med-addon="${name}"]`);
        return service?.dataset.available === 'true' && /^\d+$/.test(service.dataset.variantId || '');
      }
      get choice() { return this.select?.selectedOptions[0]; }
      get key() { return this.choice?.dataset.fontKey || 'arial'; }
      get saved() { return {key: this.key, file: this.key === 'custom' ? this.upload?.files[0] : null}; }
      sync(blank) {
        if (!this.initialized) return;
        if (blank && this.key !== 'arial') {
          this.select.value = 'Arial';
          this.upload.value = '';
          this.loadToken = (this.loadToken || 0) + 1;
          this.disposeCustomFace();
          this.showState('ready', '', 'Arial, Helvetica, sans-serif');
        }
        this.choices.forEach(choice => { choice.disabled = blank || choice.dataset.ready !== 'true'; });
        this.select.disabled = blank;
        const custom = !blank && this.key === 'custom';
        this.querySelector('.med-font__upload').hidden = !custom;
        this.upload.disabled = !custom;
        this.upload.required = custom;
        this.property.disabled = blank;
        this.property.value = this.key;
        for (const service of this.querySelectorAll('[data-med-addon]')) {
          service.disabled = blank || !this.serviceAvailable(service.dataset.medAddon);
          service.checked = !service.disabled && this.choice?.dataset.service === service.dataset.medAddon;
        }
      }
      showState(state, message, family) {
        this.dataset.state = state;
        this.parent.dataset.fontState = state;
        this.status.textContent = message;
        if (family) {
          this.select.style.fontFamily = family;
          if (this.choice) this.choice.style.fontFamily = family;
          const scope = this.parent.closest('.shopify-section, dialog') || this.parent;
          scope.style.setProperty('--med-engraving-font', family);
          this.parent.querySelectorAll('.med-engraving-text').forEach(text => { text.style.fontFamily = family; text.style.fontWeight = '400'; });
          this.parent.previewFitCache = new WeakMap();
        }
        this.parent.schedulePreviewFit();
        this.parent.dispatchEvent(new CustomEvent('med:engraving-update', {bubbles: true, detail: {fontChanged: true}}));
      }
      disposeCustomFace() {
        if (this.customFace) document.fonts.delete(this.customFace);
        this.customFace = null;
        const customChoice = this.choices?.find(choice => choice.dataset.fontKey === 'custom');
        if (customChoice) customChoice.style.removeProperty('font-family');
      }
      async choose() {
        const token = this.loadToken = (this.loadToken || 0) + 1;
        this.disposeCustomFace();
        const choice = this.choice;
        this.sync(this.parent.dataset.engravingMethod === 'none');
        this.select.style.fontFamily = getComputedStyle(this.choice).fontFamily;
        this.parent.sync(false);
        if (this.key === 'arial') {
          this.upload.value = '';
          this.showState('ready', '', 'Arial, Helvetica, sans-serif');
          return;
        }
        if (choice.disabled || !this.serviceAvailable(choice.dataset.service)) {
          this.showState('error', this.messages.unavailable);
          return;
        }
        this.showState('loading', this.messages.loading);
        try {
          let face;
          if (this.key === 'custom') {
            const file = this.upload.files[0];
            if (!file) throw new Error(this.messages.missing_file);
            if (!/\.(ttf|otf)$/i.test(file.name) || file.size < 4) throw new Error(this.messages.invalid_file);
            if (file.size > 5 * 1024 * 1024) throw new Error(this.messages.too_large);
            const bytes = await file.arrayBuffer();
            const signature = new DataView(bytes).getUint32(0);
            if (![0x00010000, 0x4f54544f, 0x74727565].includes(signature)) throw new Error(this.messages.invalid_file);
            face = new FontFace(`USMedIDCustom${++fontSequence}`, bytes);
            await face.load();
          } else {
            face = await this.loadNamedFace(choice);
          }
          if (token !== this.loadToken || !this.isConnected) return;
          document.fonts.add(face);
          if (this.key === 'custom') this.customFace = face;
          this.showState('ready', this.messages.ready, `"${face.family}"`);
          this.parent.sync(false);
        } catch (failure) {
          if (token !== this.loadToken || !this.isConnected) return;
          const known = Object.values(this.messages).includes(failure.message);
          this.showState('error', known ? failure.message : this.messages.load_failed);
        }
      }
      validationMessage() {
        if (this.parent.dataset.engravingMethod === 'none') return '';
        if (!this.initialized) return this.querySelector('[data-font-messages]') ? JSON.parse(this.querySelector('[data-font-messages]').textContent).unavailable : '';
        if (this.choice?.disabled) return this.messages.unavailable;
        if (this.dataset.state !== 'ready') return this.status.textContent || this.messages.loading;
        if (this.key === 'custom' && !this.upload.files[0]) return this.messages.missing_file;
        return '';
      }
      applyProperties(properties, extras) {
        const error = this.validationMessage();
        if (error) throw new Error(error);
        delete properties['Custom font file'];
        delete properties['Custom font name'];
        if (this.parent.dataset.engravingMethod === 'none') {
          delete properties['Engraving font'];
          delete properties._med_font_choice;
          return;
        }
        const selected = extras.filter(input => ['font-choice', 'custom-font'].includes(input.dataset.medAddon));
        const requiredService = this.choice.dataset.service;
        if (selected.length !== (requiredService ? 1 : 0) || (requiredService && selected[0].dataset.medAddon !== requiredService)) throw new Error(this.messages.unavailable);
        properties['Engraving font'] = this.choice.value;
        properties._med_font_choice = this.key;
        if (this.key === 'custom') {
          properties['Custom font file'] = this.upload.files[0];
          properties['Custom font name'] = this.upload.files[0].name;
        }
      }
      verifySaved(properties) {
        if (this.parent.dataset.engravingMethod === 'none') return true;
        if (properties?.['Engraving font'] !== this.choice.value || properties._med_font_choice !== this.key) return false;
        if (this.key !== 'custom') return true;
        try {
          const url = new URL(properties['Custom font file'], window.location.origin);
          return url.protocol === 'https:' && url.pathname.includes('/uploads/') && properties['Custom font name'] === this.upload.files[0].name;
        } catch { return false; }
      }
    }
    if (!customElements.get('med-engraving-font')) customElements.define('med-engraving-font', EngravingFont);
  })();
  } catch(e) { console.error(e); }
})();

})();
